import uuid from "uuid/v4";
import * as types from "./types";

export const requestOptions = () => {
  return {
    type: types.OPTIONS_REQUEST
  }
};

export const receiveOptions = (options) => {
  return {
    type: types.OPTIONS_SUCCESS,
    options
  }
};

export const requestOptionsFailure = (message) => {
  return {
    type: types.OPTIONS_FAILURE,
    message
  }
};

export const requestOpenTerm = () => {
  return {
    type: types.OPEN_TERM_REQUEST
  }
};

export const receiveOpenTerm = (openTerm) => {
  return {
    type: types.OPEN_TERM_SUCCESS,
    openTerm
  }
};

export const requestOpenTermFailure = (message) => {
  return {
    type: types.OPEN_TERM_FAILURE,
    message
  }
};

export const setNewUser = () => {
  return {
    type: types.SET_NEW_USER,
    newUser: true
  }
};

export const unsetNewUser = () => {
  return {
    type: types.SET_NEW_USER,
    newUser: false
  }
};

export const addAlert = (style, message) => {
  return {
    type: types.ADD_ALERT,
    alert: {
      style,
      message,
      id: uuid()
    }
  }
};

export const removeAlert = (id) => {
  return {
    type: types.REMOVE_ALERT,
    id
  }
};